let scrollContainer;
let leftBtn;
let rightBtn;
let scrollAmount = 120; // pixels to scroll per click

const pressScrollLeft = () => {
  if (!leftBtn || !scrollContainer) return;
  leftBtn.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });
};

const pressScrollRight = () => {
  if (!rightBtn || !scrollContainer) return;
  rightBtn.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });
};

function checkOverflowX() {
  const pageNavItemsWrapper = document.querySelector("#page-nav-items-wrapper");
  const pageNavItems = document.querySelector("#page-nav-items");
  if (!pageNavItemsWrapper || !pageNavItems) return;
  const isOverflowingX = pageNavItems.scrollWidth > pageNavItems.clientWidth;
  if (isOverflowingX) {
    loadButtonScrolls();
  } else {
    removeButtonScrolls();
  }
}

const updateChevronVisibility = () => {
  if (!scrollContainer || !leftBtn || !rightBtn) return;
  // At far left
  if (scrollContainer.scrollLeft <= 0) {
    leftBtn.classList.remove("page-nav-items-left-btn-show");
  } else {
    leftBtn.classList.add("page-nav-items-left-btn-show");
  }
  // At far right
  if (
    scrollContainer.scrollLeft + scrollContainer.clientWidth >=
    scrollContainer.scrollWidth - 1
  ) {
    rightBtn.classList.remove("page-nav-items-right-btn-show");
  } else {
    rightBtn.classList.add("page-nav-items-right-btn-show");
  }
};

const loadButtonScrolls = () => {
  leftBtn = document.querySelector("#page-nav-items-left-btn");
  rightBtn = document.querySelector("#page-nav-items-right-btn");

  if (!leftBtn || !rightBtn) return;

  if (
    scrollContainer.scrollLeft + scrollContainer.clientWidth >=
    scrollContainer.scrollWidth - 1
  ) {
    leftBtn.classList.add("page-nav-items-left-btn-show");
  }
  if (scrollContainer.scrollLeft <= 0) {
    rightBtn.classList.add("page-nav-items-right-btn-show");
  }

  leftBtn.addEventListener("click", pressScrollLeft);

  rightBtn.addEventListener("click", pressScrollRight);
};

const removeButtonScrolls = () => {
  if (leftBtn) {
    leftBtn.classList.remove("page-nav-items-left-btn-show");
    leftBtn.removeEventListener("click", pressScrollLeft);
  }
  if (rightBtn) {
    rightBtn.classList.remove("page-nav-items-right-btn-show");
    rightBtn.removeEventListener("click", pressScrollRight);
  }
};

const loadActiveLink = () => {
  const navItems = document.querySelector("#page-nav-items");

  if (!navItems) return;

  const currentUrl = window.location.pathname;

  console.log("currentUrl", currentUrl);

  navItems.querySelectorAll("a").forEach((link) => {
    console.log("link", link.getAttribute("href"));
    // This checks if the href matches the current path (ignoring domain and query params)
    if (currentUrl.includes(link.getAttribute("href"))) {
      link.classList.add("is-active");
    }
  });
};

// Check on page load
window.addEventListener("DOMContentLoaded", () => {
  scrollContainer = document.getElementById("page-nav-items");
  if (scrollContainer) {
    scrollContainer.addEventListener("scroll", updateChevronVisibility);
  }
  checkOverflowX();
  // Check on window resize
  window.addEventListener("resize", checkOverflowX);
  loadActiveLink();
});
